/**
 * @param $resource
 * @param {ApiRequestParams} apiRequestParams
 * @param {AppConfig} appConfig
 */
const RedemptionResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'redemptions',
        apiRequestParams.defaults(),
        {
            redeem: {
                method: 'POST',
            },
        }
    );
};

module.exports = RedemptionResource;
